import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

export default withStyles(() => ({
  tooltip: {
    fontSize: 14
  }
}))(Tooltip);
